var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "glyphicons-basic",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "circle-empty-info",
    d: "M18.903,9.58221l-.33331,2A.5.5,0,0,1,18.07642,12H15.59021a.5.5,0,0,1-.49316-.58221l.33331-2A.5.5,0,0,1,15.92358,9h2.48621A.5.5,0,0,1,18.903,9.58221ZM28,16A12,12,0,1,1,16,4,12.01343,12.01343,0,0,1,28,16Zm-3,0a9,9,0,1,0-9,9A9.01016,9.01016,0,0,0,25,16Zm-8-3H13.89038a.49993.49993,0,0,0-.48505.37872l-.25,1A.5.5,0,0,0,13.64038,15H14.4l-1.82525,6.08435A1.40763,1.40763,0,0,0,14,23h3.60962a.49993.49993,0,0,0,.48505-.37872l.25-1A.5.5,0,0,0,17.85962,21H16.6l1.82525-6.08435A1.40763,1.40763,0,0,0,17,13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.6f2d5c90b5f2cda3f18f7e640426a45b.svg";
export { ForwardRef as ReactComponent };